export const partnerCategories = [
  {
    title: 'Banks',
    partners: [
      { src: '/partners/ecobank.png', alt: 'Ecobank Ghana' },
      { src: '/partners/zenith-bank.png', alt: 'Zenith Bank Ghana' },
      { src: '/images%20(1).png', alt: 'FirstBank Ghana' },
      { src: '/images.jpeg', alt: 'Fidelity Bank Ghana' },
    ],
  },
  {
    title: 'Telcos',
    partners: [
      { src: '/mtn-logo-png_seeklogo-95716.png', alt: 'MTN Ghana' },
      { src: '/images%20(2).png', alt: 'Telecel Ghana' },
      { src: '/ATGhana.webp', alt: 'AT Ghana' },
    ],
  },
  {
    title: 'Insurance',
    partners: [
      { src: '/partners/sanlam-allianz.png', alt: 'Sanlam / Allianz' },
      { src: '/partners/prime-insurance.png', alt: 'Prime Insurance' },
      { src: '/partners/activa-insurance.png', alt: 'Activa Insurance' },
      { src: '/partners/sunu-assurances.png', alt: 'SUNU Assurances' },
    ],
  },
];

export const partnerLogos = partnerCategories.flatMap((category) => category.partners);
